export enum Step {
    DataSource,
    Date,
    ReportType,
    Dimensions,
    Metrics,
}

export const numSteps = 4;
